import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHexagonCheck } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { GoldenEggSphereSM } from '@components/main-components/media/icons/GoldenEggSphereSM';
import { Tooltip } from '@components/main-components/tooltip/Tooltip';
import { MediaQuery } from '@context/mediaQuery';

export const CollectedBadge = ({
  type = 'default',
  tooltipContent,
}: {
  type?: 'default' | 'goldenEgg';
  tooltipContent: string;
}) => {
  const { tabletLandscape } = MediaQuery.useContainer();

  const defaultLabel = (
    <div className="w-8 text-base800 hover:cursor-pointer">
      <FontAwesomeIcon size="lg" icon={faHexagonCheck} />
    </div>
  );

  const goldenEggLabel = (
    <div className="relative aspect-square w-8 hover:cursor-pointer">
      <div className="absolute -top-2 right-2 w-full">
        <GoldenEggSphereSM />
      </div>
    </div>
  );

  return (
    <Tooltip openOnClick={false}>
      <Tooltip.Trigger>{type === 'default' ? defaultLabel : goldenEggLabel}</Tooltip.Trigger>
      <Tooltip.StyledContent size="sm" side={!tabletLandscape ? 'left' : 'top'}>
        {tooltipContent}
      </Tooltip.StyledContent>
    </Tooltip>
  );
};
